import apiClient from './client';
import { InvoiceSeriesCreateRequestDto, InvoiceSeriesDto, InvoiceSeriesUpdateRequestDto } from 'interfaces/invoiceSeries';
import { invoicingRequest } from './invoicingErrors';

type CompanyId = number | string;

interface InvoicingSeriesService {
  getAll(companyId: CompanyId): Promise<InvoiceSeriesDto[]>;
  create(companyId: CompanyId, data: InvoiceSeriesCreateRequestDto): Promise<InvoiceSeriesDto>;
  update(companyId: CompanyId, id: number, data: InvoiceSeriesUpdateRequestDto): Promise<InvoiceSeriesDto>;
  activate(companyId: CompanyId, id: number): Promise<InvoiceSeriesDto>;
  deactivate(companyId: CompanyId, id: number): Promise<InvoiceSeriesDto>;
}

const series = (companyId: CompanyId) => `/tenant/companies/${companyId}/invoicing/series`;

const endpoints = {
  series,
  seriesById: (companyId: CompanyId, id: number) => `${series(companyId)}/${id}`,
  deactivate: (companyId: CompanyId, id: number) => `${series(companyId)}/${id}/deactivate`,
  activate: (companyId: CompanyId, id: number) => `${series(companyId)}/${id}/activate`,
};

export const invoicingSeriesService: InvoicingSeriesService = {
  getAll: companyId => invoicingRequest(() => apiClient.get(endpoints.series(companyId))),
  create: (companyId, data) => invoicingRequest(() => apiClient.post(endpoints.series(companyId), data)),
  update: (companyId, id, data) => invoicingRequest(() => apiClient.put(endpoints.seriesById(companyId, id), data)),
  activate: (companyId, id) => invoicingRequest(() => apiClient.post(endpoints.activate(companyId, id))),
  deactivate: (companyId, id) => invoicingRequest(() => apiClient.post(endpoints.deactivate(companyId, id))),
};
